(function () {
  function initMarquees(root) {
    root.querySelectorAll('[data-ladera-marquee]').forEach(function (marquee) {
      if (marquee.dataset.laderaInitialized === 'true') return;

      const viewport = marquee.matches('[data-ladera-marquee-viewport]') ? marquee : marquee.querySelector('[data-ladera-marquee-viewport]');
      const track = marquee.querySelector('[data-ladera-marquee-track]');
      if (!viewport || !track) return;

      marquee.dataset.laderaInitialized = 'true';
      const speedSeconds = Math.max(Number(marquee.dataset.speed) || 42, 20);
      const pauseOnHover = marquee.dataset.pauseOnHover !== 'false';
      const enableDrag = marquee.dataset.enableDrag !== 'false';
      const isThemeEditor = !!(window.Shopify && window.Shopify.designMode);
      const respectReducedMotion = marquee.dataset.respectReducedMotion === 'true';
      const reduceMotion = respectReducedMotion && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let paused = reduceMotion;
      let dragging = false;
      let pointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let moved = false;
      let suppressClick = false;
      let lastFrame = performance.now();
      let frameId = 0;
      let resizeFrameId = 0;
      let virtualScrollLeft = viewport.scrollLeft;

      function removeShopifyEditorAttributes(element) {
        Array.prototype.slice.call(element.attributes).forEach(function (attribute) {
          if (attribute.name.indexOf('data-shopify') === 0) element.removeAttribute(attribute.name);
        });
      }

      function cloneAnnouncementSet(sourceSet) {
        const clone = sourceSet.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach(function (link) {
          link.setAttribute('tabindex', '-1');
        });
        clone.querySelectorAll('*').forEach(removeShopifyEditorAttributes);
        removeShopifyEditorAttributes(clone);
        return clone;
      }

      function firstSet() {
        return track.querySelector('.ladera-announcement__set');
      }

      function fillTrack() {
        const sourceSet = track.querySelector('.ladera-announcement__set[aria-hidden="true"]') || firstSet();
        const width = loopWidth();
        let safety = 0;
        if (!sourceSet || !width) return;
        while (track.scrollWidth < viewport.clientWidth + width && safety < 8) {
          track.appendChild(cloneAnnouncementSet(sourceSet));
          safety += 1;
        }
      }

      function loopWidth() {
        const set = firstSet();
        return set ? set.scrollWidth : track.scrollWidth / Math.max(track.children.length, 1);
      }

      function normalizeScroll() {
        const width = loopWidth();
        if (!width) return;
        if (virtualScrollLeft >= width) virtualScrollLeft -= width;
        if (virtualScrollLeft < 0) virtualScrollLeft += width;
        viewport.scrollLeft = virtualScrollLeft;
      }

      function animate(now) {
        const elapsed = Math.min(now - lastFrame, 80);
        lastFrame = now;
        if (!paused && !dragging && (!document.hidden || isThemeEditor)) {
          virtualScrollLeft += (loopWidth() / speedSeconds) * (elapsed / 1000);
          normalizeScroll();
        }
        frameId = window.requestAnimationFrame(animate);
      }

      function handleResize() {
        window.cancelAnimationFrame(resizeFrameId);
        resizeFrameId = window.requestAnimationFrame(function () {
          fillTrack();
          virtualScrollLeft = viewport.scrollLeft;
          normalizeScroll();
        });
      }

      function pause() {
        if (pauseOnHover && !isThemeEditor) paused = true;
      }

      function resume() {
        if (!dragging && (!document.hidden || isThemeEditor) && !reduceMotion) paused = false;
      }

      function stopDrag(event) {
        if (!dragging || (event && event.pointerId !== pointerId)) return;
        dragging = false;
        viewport.classList.remove('is-dragging');
        if (viewport.hasPointerCapture && viewport.hasPointerCapture(pointerId)) viewport.releasePointerCapture(pointerId);
        if (moved) {
          suppressClick = true;
          window.setTimeout(function () { suppressClick = false; }, 80);
        }
        pointerId = null;
        normalizeScroll();
        resume();
      }

      viewport.addEventListener('mouseenter', pause);
      viewport.addEventListener('mouseleave', resume);
      viewport.addEventListener('focusin', pause);
      viewport.addEventListener('focusout', resume);
      viewport.addEventListener('click', function (event) {
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      if (enableDrag) {
        viewport.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          dragging = true;
          pointerId = event.pointerId;
          startX = event.clientX;
          startScrollLeft = viewport.scrollLeft;
          moved = false;
          paused = true;
          viewport.classList.add('is-dragging');
          if (viewport.setPointerCapture) viewport.setPointerCapture(pointerId);
        });
        viewport.addEventListener('pointermove', function (event) {
          if (!dragging || event.pointerId !== pointerId) return;
          const delta = event.clientX - startX;
          if (Math.abs(delta) > 4) moved = true;
          viewport.scrollLeft = startScrollLeft - delta;
          virtualScrollLeft = viewport.scrollLeft;
        });
        viewport.addEventListener('pointerup', stopDrag);
        viewport.addEventListener('pointercancel', stopDrag);
        viewport.addEventListener('lostpointercapture', stopDrag);
      }

      marquee._laderaCleanup = function () {
        window.cancelAnimationFrame(frameId);
        window.cancelAnimationFrame(resizeFrameId);
        window.removeEventListener('resize', handleResize);
      };
      fillTrack();
      window.addEventListener('resize', handleResize);
      frameId = window.requestAnimationFrame(animate);
    });
  }

  function initAnnouncementCarousels(root) {
    root.querySelectorAll('[data-ladera-announcement-carousel]').forEach(function (carousel) {
      if (carousel.dataset.laderaCarouselInitialized === 'true') return;

      const slides = Array.prototype.slice.call(carousel.querySelectorAll('.ladera-announcement__slide'));
      if (slides.length <= 1) return;

      carousel.dataset.laderaCarouselInitialized = 'true';
      const speedSeconds = Math.max(Number(carousel.dataset.speed) || 15, 3);
      const pauseOnHover = carousel.dataset.pauseOnHover !== 'false';
      const isThemeEditor = !!(window.Shopify && window.Shopify.designMode);
      let index = Math.max(slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }), 0);
      let paused = false;
      let timer = 0;
      slides[index].classList.add('is-active');

      function showSlide(nextIndex) {
        slides[index].classList.remove('is-active');
        index = (nextIndex + slides.length) % slides.length;
        slides[index].classList.add('is-active');
      }

      function tick() {
        if (!paused && (!document.hidden || isThemeEditor)) showSlide(index + 1);
      }

      function pause() {
        if (pauseOnHover && !isThemeEditor) paused = true;
      }

      function resume() {
        if (pauseOnHover) paused = false;
      }

      carousel.addEventListener('mouseenter', pause);
      carousel.addEventListener('mouseleave', resume);
      carousel.addEventListener('focusin', pause);
      carousel.addEventListener('focusout', resume);
      timer = window.setInterval(tick, speedSeconds * 1000);

      carousel._laderaCarouselCleanup = function () {
        window.clearInterval(timer);
      };
    });
  }

  function initProofCarousels(root) {
    root.querySelectorAll('[data-ladera-proof-carousel]').forEach(function (carousel) {
      if (carousel.dataset.laderaProofInitialized === 'true') return;

      const track = carousel.querySelector('[data-ladera-proof-track]');
      const previous = carousel.querySelector('[data-ladera-proof-prev]');
      const next = carousel.querySelector('[data-ladera-proof-next]');
      if (!track || !previous || !next) return;

      carousel.dataset.laderaProofInitialized = 'true';

      function scrollStep() {
        const tile = track.querySelector('.ladera-product-media-proof__tile');
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return tile ? tile.getBoundingClientRect().width + gap : track.clientWidth;
      }

      previous.addEventListener('click', function () {
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
    });
  }

  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('[data-ladera-menu-toggle]');
    if (!toggle) return;
    const header = toggle.closest('.ladera-header');
    if (!header) return;
    const open = header.getAttribute('data-open') === 'true';
    header.setAttribute('data-open', open ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ladera-header[data-open="true"]').forEach(function (header) {
      header.setAttribute('data-open', 'false');
      const toggle = header.querySelector('[data-ladera-menu-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });

  function init() {
    initMarquees(document);
    initAnnouncementCarousels(document);
    initProofCarousels(document);
  }

  document.addEventListener('visibilitychange', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-ladera-marquee]').forEach(function (marquee) {
      if (marquee._laderaCleanup) marquee._laderaCleanup();
    });
    event.target.querySelectorAll('[data-ladera-announcement-carousel]').forEach(function (carousel) {
      if (carousel._laderaCarouselCleanup) carousel._laderaCarouselCleanup();
    });
  });
  init();
})();
